const AI_FLOW_URL = '/en/wta?landingPageAlias=w2a-ai-cc&utm_source=ai_sololearn_com&utm_medium=internal_website';

export const openAIFlow = () => {
  window.location.replace(AI_FLOW_URL);
};
